import useAccessVoter from "v4/hooks/useAccessVoter";

export default function CustomEventTriggerVoter() {
    const {hasRole} = useAccessVoter();

    const canAccessCustomEventTrigger = () => {
        return hasRole('ROLE_SUPERADMIN') || hasRole('ROLE_SYSTEM');
    }

    return ({canAccessCustomEventTrigger})
}
